module.exports = __webpack_public_path__ + "static/Twilio1-70a673792209c8b6e5fd97da5bc055f0.png";